import {
	MimaButton,
	MimaText,
	Modal,
	ReceiptCheckBox as RCB,
	MimaDropdown,
} from '../../components';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import { Formik } from 'formik';
import React from 'react';

const PayrollSummary = ({
	closeModal,
	schemaValidation,
	loading,
	onSubmit,
	goBack,
}) => {
	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<div className={styles.ps}>
				<MimaText variant="subtitle" align="center" mb={2}>
					Create/Refresh Payroll
				</MimaText>
				<Formik
					initialValues={{
						week: '',
						settlementCycle: 'MONTHLY',
						biWeek: '',
						month: '',
						year: '',
					}}
					validationSchema={schemaValidation}
					onSubmit={onSubmit}>
					{({ handleSubmit, setFieldValue, values, errors, touched }) => (
						<>
							<MimaDropdown
								labelTitle="Year"
								placeholder="Select"
								name="year"
								value={values.year}
								id="year"
								onChange={data => {
									setFieldValue('year', data.key);
								}}
								data={[
									{
										value: '2023',
										key: '2023',
									},
									{
										value: '2024',
										key: '2024',
									},
									{
										value: '2025',
										key: '2025',
									},
									{
										value: '2026',
										key: '2026',
									},
									{
										value: '2027',
										key: '2027',
									},
									{
										value: '2028',
										key: '2028',
									},
									{
										value: '2029',
										key: '2029',
									},
									{
										value: '2030',
										key: '2030',
									},
								]}
								touched={touched.year}
								error={errors.year}
							/>
							<MimaDropdown
								labelTitle="Month"
								placeholder="Select"
								name="month"
								value={values.month}
								id="month"
								onChange={data => {
									setFieldValue('month', data.key);
								}}
								data={[
									{
										value: 'January',
										key: 1,
									},
									{
										value: 'February',
										key: 2,
									},
									{
										value: 'March',
										key: 3,
									},
									{
										value: 'April',
										key: 4,
									},
									{
										value: 'May',
										key: 5,
									},
									{
										value: 'June',
										key: 6,
									},
									{
										value: 'July',
										key: 7,
									},
									{
										value: 'August',
										key: 8,
									},
									{
										value: 'September',
										key: 9,
									},
									{
										value: 'October',
										key: 10,
									},
									{
										value: 'November',
										key: 11,
									},
									{
										value: 'December',
										key: 12,
									},
								]}
								touched={touched.month}
								error={errors.month}
							/>
							<div className={styles.checks}>
								<RCB
									title="WEEKLY"
									id="WEEKLY"
									name="settlementCycle"
									onChange={() => {
										setFieldValue('settlementCycle', 'WEEKLY');
									}}
									checked={values.settlementCycle === 'WEEKLY'}
									value="WEEKLY"
								/>
								<RCB
									title="BI-WEEKLY"
									id="BI-WEEKLY"
									name="settlementCycle"
									onChange={() => {
										setFieldValue('settlementCycle', 'BI-WEEKLY');
									}}
									checked={values.settlementCycle === 'BI-WEEKLY'}
									value="BI-WEEKLY"
								/>
								<RCB
									title="MONTHLY"
									id="MONTHLY"
									name="settlementCycle"
									onChange={() => {
										setFieldValue('settlementCycle', 'MONTHLY');
									}}
									checked={values.settlementCycle === 'MONTHLY'}
									value="MONTHLY"
								/>
							</div>
							{values.settlementCycle === 'WEEKLY' && (
								<MimaDropdown
									labelTitle="Week"
									placeholder="Select"
									name="week"
									value={values.week}
									id="week"
									onChange={data => {
										setFieldValue('week', data.key);
									}}
									data={[
										{
											value: 'Week 1',
											key: 1,
										},
										{
											value: 'Week 2',
											key: 2,
										},
										{
											value: 'Week 3',
											key: 3,
										},
										{
											value: 'Week 4',
											key: 4,
										},
									]}
									touched={touched.week}
									error={errors.week}
								/>
							)}
							{values.settlementCycle === 'BI-WEEKLY' && (
								<MimaDropdown
									labelTitle="Bi-Week"
									placeholder="Select"
									name="biWeek"
									value={values.biWeek}
									id="biWeek"
									onChange={data => {
										setFieldValue('biWeek', data.key);
									}}
									data={[
										{
											value: 'Bi-Week 1',
											key: 1,
										},
										{
											value: 'Bi-Week 2',
											key: 2,
										},
									]}
									touched={touched.biWeek}
									error={errors.biWeek}
								/>
							)}
							<MimaButton
								title="Continue"
								onClick={handleSubmit}
								type="submit"
								loading={loading}
								mt={2}
							/>
						</>
					)}
				</Formik>
			</div>
		</Modal>
	);
};

export default PayrollSummary;
